module.exports = __webpack_public_path__ + "img/compatibility.515ebd30.svg";